export const AUTH_KEY_CONST = 'auth_key';
export const OTHER_CONSTANT = 'OTHER_CONSTANT';



// WEBPACK FOOTER //
// ./src/constants/LocalStorage.js